import {
  MODULE_LAYOUT_LABELS,
  MODULE_TYPE_LABELS,
} from "entities/modules/constants";
import { ModuleType } from "entities/modules/types";
import { PageModuleData, PageModuleStatus } from "entities/pages/types";
import { getChipColor } from "modules/brands/utils";
import Chip from "shared/components/Chip";
import { Column } from "shared/components/DragNDropTable/helpers";
import DropdownList, {
  DropdownListItemProps,
} from "shared/components/DropdownList";
import { COLOR_PRIMARY_MAIN } from "shared/theme/colors";
import { ArrowForwardIcon } from "shared/theme/icons/ArrowForwardIcon";
import { StyledActionWrapper } from "../../../../styled";
import { ColumnsProps } from "./types";

const renderStatusCell = (item: PageModuleData) => {
  const isActive = item.status === PageModuleStatus.Active;
  const color = getChipColor(isActive);
  const title = Boolean(isActive) ? "Active" : "Inactive";

  return <Chip title={title} bgColor={color} />;
};

export const getPageModulesColumns = ({
  moduleDetailsDrawer,
  handleStatus,
  onDeleteClick,
  readOnly,
}: ColumnsProps): Column<PageModuleData>[] => {
  const renderActions = (module: PageModuleData) => {
    if (readOnly) {
      return (
        <StyledActionWrapper
          onClick={() => moduleDetailsDrawer.openDrawer(module)}
        >
          <ArrowForwardIcon color={COLOR_PRIMARY_MAIN} />
        </StyledActionWrapper>
      );
    }

    const isActive = module.status === PageModuleStatus.Active;
    const statusTitle = isActive ? "Unpublish" : "Publish";

    let items: DropdownListItemProps[] = [
      {
        title: "Edit",
        style: "normal",
        onClick: () => moduleDetailsDrawer.openDrawer(module),
      },
      {
        title: statusTitle,
        style: "normal",
        onClick: () =>
          handleStatus({
            moduleId: module.id,
            status:
              module.status === PageModuleStatus.Active
                ? PageModuleStatus.Draft
                : PageModuleStatus.Active,
          }),
      },
      {
        title: "Delete",
        style: "remove",
        onClick: () => onDeleteClick(module),
      },
    ];

    return <DropdownList items={items} />;
  };

  return [
    {
      headerName: "Module name",
      width: "35%",
      renderCell: (item: PageModuleData) => item.name,
    },
    {
      headerName: "Type",
      width: "20%",
      headerAlign: "left",
      align: "left",
      renderCell: (item: PageModuleData) => MODULE_TYPE_LABELS[item.type],
    },
    {
      headerName: "Layout",
      width: "25%",
      headerAlign: "left",
      align: "left",
      renderCell: (item: PageModuleData) =>
        item.layout ? MODULE_LAYOUT_LABELS[item.layout] : "N/A",
    },
    {
      headerName: "Status",
      width: "5%",
      align: "left",
      headerAlign: "left",
      renderCell: renderStatusCell,
    },
    {
      headerName: "",
      width: "10%",
      align: "right",
      headerAlign: "right",
      renderCell: (item: PageModuleData) => {
        return renderActions(item);
      },
    },
  ];
};

export const getTextForDeletingPopup = (module: PageModuleData) => {
  if (module.type === ModuleType.Games && module.selectedGames?.length) {
    return `This module contain ${module.selectedGames.length} games. Are you sure you want to delete this module?`;
  }
  return "Are you sure you want to delete this module?";
};
